// Represents possible errors returned by the Tauri OC plugin
export var AndroidWebAuthnErrorCode;
(function (AndroidWebAuthnErrorCode) {
    // Create passkey errors
    AndroidWebAuthnErrorCode["CreateProviderError"] = "systemProviderError";
    AndroidWebAuthnErrorCode["CreateNoProviders"] = "noProviders";
    AndroidWebAuthnErrorCode["CreatePasskeyAlreadyExists"] = "passkeyAlreadyExists";
    AndroidWebAuthnErrorCode["CreatePasskeyeFailed"] = "passkeyCreateFailed";
    // Sign in errors
    AndroidWebAuthnErrorCode["AuthEmptyResponse"] = "authEmptyResponse";
    AndroidWebAuthnErrorCode["AuthNoPasskey"] = "noPasskey";
    AndroidWebAuthnErrorCode["AuthDeviceNotSupported"] = "deviceNotSupported";
    AndroidWebAuthnErrorCode["AuthTransientError"] = "transientSystemError";
    AndroidWebAuthnErrorCode["AuthCredentialError"] = "credentialError";
    AndroidWebAuthnErrorCode["AuthFetchFailed"] = "passkeyFetchFailed";
    // Common errors
    AndroidWebAuthnErrorCode["CommonUserCancelled"] = "userCancelled";
    AndroidWebAuthnErrorCode["CommonSystemNotReady"] = "systemNotReady";
    AndroidWebAuthnErrorCode["CommonNoLockScreen"] = "noLockScreen";
    AndroidWebAuthnErrorCode["CommonSecurityDenied"] = "securityDenied";
    AndroidWebAuthnErrorCode["CommonDomPasskeyError"] = "domPasskeyError";
    AndroidWebAuthnErrorCode["CommonInterrupted"] = "interrupted";
    // Other errors, not necessarily returned by the tauri plugin
    AndroidWebAuthnErrorCode["JsonAuthDataError"] = "jsonAuthDataError";
    AndroidWebAuthnErrorCode["MissingErrorIdentifier"] = "missingErrorIdentifier";
    AndroidWebAuthnErrorCode["FailedToCacheWebAuthnKey"] = "failedToCacheWebAuthnKey";
})(AndroidWebAuthnErrorCode || (AndroidWebAuthnErrorCode = {}));
export function decodePluginError(errStr) {
    try {
        const { code, msg } = JSON.parse(errStr);
        return {
            code: errorCodeFromStr(code),
            msg,
        };
    }
    catch (e) {
        console.error(errStr, e);
        return {
            code: AndroidWebAuthnErrorCode.JsonAuthDataError,
            msg: "Auth data received from the credentials manager is malformed json",
        };
    }
}
function errorCodeFromStr(c) {
    switch (c) {
        // Create passkey errors
        case "SYSTEM_PROVIDER_ERROR":
            return AndroidWebAuthnErrorCode.CreateProviderError;
        case "NO_PROVIDERS":
            return AndroidWebAuthnErrorCode.CreateNoProviders;
        case "PASSKEY_ALREADY_EXISTS":
            return AndroidWebAuthnErrorCode.CreatePasskeyAlreadyExists;
        case "PASSKEY_CREATE_FAILED":
            return AndroidWebAuthnErrorCode.CreatePasskeyeFailed;
        // Sign in errors
        case "AUTH_EMPTY_RESPONSE":
            return AndroidWebAuthnErrorCode.AuthEmptyResponse;
        case "NO_PASSKEY":
            return AndroidWebAuthnErrorCode.AuthNoPasskey;
        case "DEVICE_NOT_SUPPORTED":
            return AndroidWebAuthnErrorCode.AuthDeviceNotSupported;
        case "TRANSIENT_SYSTEM_ERROR":
            return AndroidWebAuthnErrorCode.AuthTransientError;
        case "CREDENTIAL_ERROR":
            return AndroidWebAuthnErrorCode.AuthCredentialError;
        case "PASSKEY_FETCH_FAILED":
            return AndroidWebAuthnErrorCode.AuthFetchFailed;
        // Common errors
        case "USER_CANCELLED":
            return AndroidWebAuthnErrorCode.CommonUserCancelled;
        case "SYSTEM_NOT_READY":
            return AndroidWebAuthnErrorCode.CommonSystemNotReady;
        case "NO_SCREEN_LOCK":
            return AndroidWebAuthnErrorCode.CommonNoLockScreen;
        case "SECURITY_DENIED":
            return AndroidWebAuthnErrorCode.CommonSecurityDenied;
        case "DOM_PASSKEY_ERROR":
            return AndroidWebAuthnErrorCode.CommonDomPasskeyError;
        case "INTERRUPTED":
            return AndroidWebAuthnErrorCode.CommonInterrupted;
        default:
            console.warn("Missing error identifier for error code in AndroidWebAuth errors!", c);
            return AndroidWebAuthnErrorCode.MissingErrorIdentifier;
    }
}
